<template>
  <v-row dense justify="center">
    <v-col cols="12" class="content">
      <v-card style="position: relative">
        <v-btn
          @click="editClient()"
          elevation="2"
          class="fab-buttons "
          fab
          absolute
          top
          color="primary"
          right>
          <v-icon v-if="customers.length>0">
            mdi-playlist-edit
          </v-icon>
          <v-icon v-else>
            mdi-account-plus
          </v-icon>
        </v-btn>
        <v-btn
          @click="goToEdit()"
          class="fab-buttons button-left"
          elevation="2"
          fab
          absolute
          top
          color="secondary"
          right>
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-form ref="form">
          <v-col cols="12">
            <div v-if="reportInfo" class="text-overline mb-4">
              <span v-if="reportInfo.project">{{ reportInfo.project.name }};</span>
              {{ reportInfo.date }};
              <span v-if="reportInfo.place">{{ reportInfo.place.name }};</span>
              <span v-if="reportInfo.hours">{{ reportInfo.hours }} часа;</span>
              {{ reportInfo.users }}
            </div>
            <v-row justify="start">
              <v-col v-for="product in globalProds"
                     :key="product.value"
                     cols="12"
                     lg="4">
                <v-text-field v-model="product.amount" :label="product.name" :readonly="product.readOnly" />
              </v-col>
            </v-row>
            <v-row v-if="customers.length > 0">
              <v-col cols="12">
                <v-expansion-panels>
                  <v-expansion-panel v-for="client in customers" :key="client.code">
                    <v-expansion-panel-header>
                      {{ client.code }}
                      <div class="text-right">
                        <v-chip
                          v-for="item in client.customerGroups"
                          :key="item.name"
                          :color="groupColors[item.name]"
                          class="ma-2"
                          small>
                          {{ item.name }}
                        </v-chip>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table class="mb-5">
                        <template v-slot:default>
                          <tbody>
                            <tr
                              v-for="item in client.consultings"
                              :key="item.name">
                              <td>{{ item.name }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                      <v-btn
                        @click="editClient(client.code)"
                        color="primary">
                        <span>
                          <v-icon>mdi-pencil</v-icon>
                        </span>
                      </v-btn>
                      <v-btn
                        @click="deleteClient(client.code)"
                        color="error">
                        <span>
                          <v-icon>mdi-delete</v-icon></span>
                      </v-btn>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
            <v-row v-else-if="reportType!=='outreach'">
              <v-col cols="12">
                Клиенты отсутствуют
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn
                  :loading="loading"
                  @click="submit()"
                  color="primary">
                  <span>Сохранить</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {mapState} from 'vuex'
import ReportsMixin from '../new/ReportsMixin'

export default {
  name: "ReportPsychCustomersList",
  mixins: [ReportsMixin],
  props: {
    reportId: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      loading: false,
      groupColors: {'СР':'pink','ЛУН':'green','МСМ':'blue'},
      reportTypes: {
        'lgbtq': 'ЛГБТКИ+',
        'outreach': 'Аутрич',
        'casemanagement': 'КМ',
        'seminar': 'Семинар',
        'psych': 'Пcихолог',
        'lawyers': 'Юристы'
      }
    }
  },
  computed: {
    ...mapState({
      customers: state => state.newOutreachReports.customers,
      globalIndicatorsList: state => state.tableData.globalIndicators,
      consultingsList: state => state.tableData.consultings

    }),
    reportType () {
      return this.$route.meta.reportType
    },
    custConsults () {
      let consults = {}
      let vm = this
      this.customers.forEach(cust => {
          let consultations = cust.consultings && cust.consultings.length>0 ? cust.consultings : cust.consultations
          if (consultations){
            consultations.map(cons =>
              {
                let consultations_id = parseInt(cons.consultations_id ? cons.consultations_id : cons.id)
                let reports_id = parseInt(cons.reports_id ? cons.reports_id : cons.report)
                let cons_data
                if  (vm.$store.state.newOutreachReports.id !== 'new') {
                  cons_data = vm.consultingsList.filter(v => v.id === consultations_id && parseInt(this.$store.state.newOutreachReports.id) === reports_id)[0]
                }  else {
                  cons_data = vm.consultingsList.filter(v => v.id === consultations_id)[0]
                }
                if (cons_data) {
                  if (cons_data.name in consults) consults[cons_data.name].push(cust)
                      else consults[cons_data.name] = [cust]
                }
              })
          }

      })
      return consults
    },
    globalProds: {
       get () {
         let vm = this
         let filtered = []
         if (vm.globalIndicatorsList && vm.globalIndicatorsList.length > 0) {
           filtered = vm.globalIndicatorsList.filter(v => v.report_type.indexOf(vm.reportTypes[vm.$route.meta.reportType]) > -1)
           filtered.map(v => {
                 v['amount'] = v['name'] === 'Количество кейсов' ? vm.customers.length : v['amount']
                 v['readOnly'] = v['name'] === 'Количество кейсов'
                 return v
               }
           )
           this.$store.commit("newOutreachReports/setglobalIndicators", filtered)

         }
         return filtered
       },
       set (indicator) {
         //console.log('is it set> ', indicator)
         this.$store.commit("newOutreachReports/setglobalIndicators", indicator)
       },
     },
  },
  methods: {

    addCustomer () {
      let route = this.reportTypeRoute+'Client'
      this.$router.push({name: route, params: {reportId: this.reportId, customerId: 'new'}})
    },
     goToEdit () {
      let route = this.reportTypeRoute+'Form'
      this.$router.push({name: route, params: {reportId: this.$store.state.newOutreachReports.id}})
    },
    deleteClient (code) {
      this.$store.commit("newOutreachReports/deleteCustomer", code)
    },
    setOther (data) {
      this.$store.commit("newOutreachReports/setOther", data)
    },
    editClient () {
      // let vm = this
      let route = this.reportTypeRoute+'Client'

      this.$router.push({name: route, params: {reportId: this.$store.state.newOutreachReports.id, customers: this.customers}})
    },
    async submit () {
      if (this.validate()) {
        this.loading = true
        try {
          await this.$store.dispatch("newOutreachReports/saveReport", {reportId:this.$store.state.newOutreachReports.id,type:this.reportType, stage:'finished'})
          this.$store.dispatch("alert/success", "Отчет сохранен.")
          this.$store.commit("newOutreachReports/clearReport")
        } catch (e) {
          //console.log(e)
          this.$store.dispatch("alert/error", "Произошла ошибка. Попробуйте сохранить отчет позже.")
        } finally {
          this.loading = false

          this.$router.push({name: 'ReportsList'})
        }
      }
    },
    validate () {
      return this.$refs.form.validate()
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-dialog {
  background-color: #303030
}

.outreach-header {
  background-color: #1976d2 !important;
  opacity: 0.8;
  padding: 10px
}

.case-header {
  background-color: #ffc107 !important;
  opacity: 0.8;
  padding: 10px
}

.read-only-header {
  background-color: gray !important;
  opacity: 0.8;
  padding: 10px
}

.button-left {
  right: 86px !important;
}

.fab-buttons {
  top: -48px !important;
}

.content {
  max-width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/new/ReportPsychCustomersList.vue